import PodCalls from './modules/PodCalls';
import NodeCalls from './modules/NodeCalls';
import UserCalls from './modules/UserCalls';
import UsageCalls from './modules/UsageCalls';
import SystemCalls from './modules/SystemCalls';
import SearchCalls from './modules/SearchCalls';
import CommonCalls from './modules/CommonCalls';
import ServiceCalls from './modules/ServiceCalls';
import AccesslinkCalls from './modules/AccesslinkCalls';
import UploadLinkCalls from './modules/UploadLinkCalls';
import PodCommentCalls from './modules/PodCommentCalls';
import PodTranscriptCalls from './modules/PodTranscriptCalls';
import NotificationCalls from './modules/NotificationCalls';
import PodLabelCalls from './modules/PodLabelCalls';
import PodLegalCalls from './modules/PodLegalCalls';
import ReportCalls from './modules/ReportCalls';
import EmbedMediaCalls from './modules/EmbedMediaCalls';
import ReviewerCalls from './modules/ReviewerCalls';
import AccountCalls from './modules/AccountCalls';
import SubtitleCalls from './modules/SubtitleCalls';
import TenantCalls from './modules/TenantCalls';
import TenantConnectionsCalls from './modules/TenantConnectionsCalls';
import FtpUserCalls from './modules/FtpUserCalls';
import LabelCalls from './modules/LabelCalls';
import RecycleBinCalls from "@/api/modules/RecycleBinCalls";
import ApiClientCalls from "@/api/modules/ApiClientCalls";
import AnnouncementCalls from "@/api/modules/AnnouncementCalls";
import AuthenticityCheckCalls from "@/api/modules/AuthenticityCheckCalls";
import DownloadCalls from "@/api/modules/DownloadCalls";
import WebhookIntegrationCalls from '@/api/modules/WebhookIntegrationCalls';
import GuidedRecordingCalls from '@/api/modules/GuidedRecordingCalls';
import { axiosClient } from '@/api/AxiosInstance.js';

class Api {
  static pod = PodCalls;
  static node = NodeCalls;
  static user = UserCalls;
  static usage = UsageCalls;
  static system = SystemCalls;
  static search = SearchCalls;
  static common = CommonCalls;
  static service = ServiceCalls;
  static comment = PodCommentCalls;
  static transcript = PodTranscriptCalls;
  static accesslink = AccesslinkCalls;
  static uploadlink = UploadLinkCalls;
  static notification = NotificationCalls;
  static podlabel = PodLabelCalls;
  static podlegal = PodLegalCalls;
  static label = LabelCalls;
  static report = ReportCalls;
  static embedmedia = EmbedMediaCalls;
  static reviewer = ReviewerCalls;
  static account = AccountCalls;
  static subtitle = SubtitleCalls;
  static tenant = TenantCalls;
  static tenantConnections = TenantConnectionsCalls;
  static ftpUser = FtpUserCalls;
  static recycleBin = RecycleBinCalls;
  static apiclient = ApiClientCalls;
  static announcement = AnnouncementCalls;
  static authenticityCheck = AuthenticityCheckCalls;
  static download = DownloadCalls;
  static webhookIntegration = WebhookIntegrationCalls;
  static guidedRecording = GuidedRecordingCalls;

  static entryPointHeader = null;

  static setEntryPoint(directoryID) {
    this.entryPointHeader = directoryID ? directoryID.toString() : null;
  }

  static configure(app) {
    // Get the router from app
    const router = app.config.globalProperties.$router;
    axiosClient.setRouter(router);
  }
}

export default Api;
